import styled from "styled-components";
import { colors } from "@/theme";

export const TransactionCompleteDialogTitleContainer = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
`;

export const TransactionCompleteDialogOrderIdContainer = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
`;
